import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LocationStrategy, PathLocationStrategy, DatePipe } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import es from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';
import { AppComponent } from './app.component';
import { FooterComponent } from './components/shared/footer/footer.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AuthJwtInterceptorService } from './services/auth-jwt-interceptor.service';
import { Helpers } from './helpers/helpers';
import { ToastrModule } from 'ngx-toastr';
import { CustomValidators } from './helpers/custom-validators';
import { Select2Module } from 'ng-select2-component';
import { FormsModule } from '@angular/forms';
import { HeaderComponent } from './components/shared/header/header.component';
import { SharedModule } from './components/shared/shared.module';
import { DefaultLayoutComponent } from './containers';
import { AppRoutingModule } from './app.routing';
import { RouterModule } from '@angular/router';
import { SidebarComponent } from './components/shared/sidebar/sidebar.component';
import { LoginComponent } from './components/login/login.component';
import { MenuComponent } from './components/shared/menu/menu.component';
import { FileValidationService } from './services/file-interceptor.service';


registerLocaleData(es);

const APP_CONTAINERS = [
  DefaultLayoutComponent
];

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    MenuComponent,
    ...APP_CONTAINERS
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    RouterModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    Select2Module,
    NgbModule,
    SharedModule,
    ToastrModule.forRoot(),
    FormsModule
  ],
  providers: [
    Helpers,
    CustomValidators,
    DatePipe,
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy
    },
    { provide: LOCALE_ID, useValue: 'es-ES' },
    { provide: HTTP_INTERCEPTORS, useClass: AuthJwtInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: FileValidationService, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
